import React, { useEffect } from "react";
import history from "history.js";
import queryString from "query-string";

const CriarEmpresa = () => {

    useEffect(() => {
        const { search } = document.location;
        if (search) {
            var AQueryParsed = queryString.parse(search);
            if (!_.isUndefined(AQueryParsed.ctx) && !_.isNull(AQueryParsed.ctx)) {
                sessionStorage.setItem("ctx", AQueryParsed.ctx);
            }
            if (!_.isUndefined(AQueryParsed.sistema) && !_.isNull(AQueryParsed.sistema)) {
                sessionStorage.setItem("sistema", AQueryParsed.sistema);
            }
            if (!_.isUndefined(AQueryParsed.plano) && !_.isNull(AQueryParsed.plano)) {
                sessionStorage.setItem("plano", AQueryParsed.plano);
            }
        }
        sessionStorage.setItem("CriarTeste", 2);
        history.push("/pub-register");
    });

    return (
        <React.Fragment>
        </React.Fragment>
    );

};

export default CriarEmpresa;
